import { useCallback } from 'react'
import { useRouter } from 'next/navigation'
import PropTypes from 'prop-types'
import { Box, Divider, MenuItem, MenuList, Popover, Typography } from '@mui/material'
import { useAuth } from 'src/hooks/use-auth'
import axios from 'axios'

export const AccountPopover = (props) => {
  const { anchorEl, onClose, open } = props
  const router = useRouter()
  const auth = useAuth()

  const handleSignOut = useCallback(async () => {
    try {
      const response = await axios.post(`${process.env.NEXT_PUBLIC_API_URL}/auth/logout`, {}, { withCredentials: true })
      console.log(response)
    } catch (error) {
      console.error('Logout failed:', error)
      return
    }
    onClose?.()
    auth.signOut()
    router.push('/login')
  }, [onClose, auth, router])

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 200 } }}
    >
      <MenuList
        disablePadding
        dense
        sx={{
          p: '8px',
          '& > *': {
            borderRadius: 1,
          },
        }}
      >
        <MenuItem onClick={handleSignOut}>ログアウト</MenuItem>
      </MenuList>
    </Popover>
  )
}

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
}
